import {
  STYLE_WIDE_SET,
} from '../mutation-types';

import Vue from 'vue';
import store from 'store';

const state = {
  wide: false,
};

const mutations = {
  [STYLE_WIDE_SET] (state, wide) {
    store.set('wide', wide);
    Vue.set(state, 'wide', wide);
  },
};

export default {
  state,
  mutations,
};



// WEBPACK FOOTER //
// ./src/vuex/modules/style.js